/*
 * @Author: 小周
 * @Date: 2024-06-17 09:58:13
 * @LastEditTime: 2024-06-17 11:43:50
 * @LastEditors: MrZHLF
 * @Description:
 */

import styles from './index.module.scss'

const BaseUser = ({ user }) => {
  return (
    <div className={styles['comment_wrap-list-user']}>
      <div className={styles.avatar}>
        {user.commentUserIcon ? (
          <img className={styles.icon} src={user.commentUserIcon} alt="" />
        ) : (
          <img
            className={styles.icon}
            src={require('./../../assets/images/user.png')}
            alt=""
          />
        )}

        {user.identifyFlag == 2 ? (
          <img
            className={styles.prove}
            src="./../../assets/images/blue.png"
            alt=""
          />
        ) : null}
        {user.identifyFlag == 1 ? (
          <img
            className={styles.prove}
            src="./../../assets/images/yellow.png"
            alt=""
          />
        ) : null}
      </div>
      <div className={styles.name}>{user.commentUserNickname}</div>
    </div>
  )
}

export default BaseUser
